import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { BusinessEntityDto } from './models/business-entities.model';

export const BusinessEntitiesActions = createActionGroup({
  source: 'Business Entities',
  events: {
    Init: emptyProps(),
    'Get Business Entities': props<{ tenantUuid: string }>(),
    'Load Success': props<{ businessEntities: readonly BusinessEntityDto[] }>(),
    'Load Failure': props<{ error: unknown }>(),
    Clear: emptyProps(),
  },
});
